import { OrganizationApi, ToastStateHandler } from '../../../api';
import { useContainer } from '../../useContainer';
import { GoogleImportDto } from '../../../commonTypes/organization.types';
import { useEffect } from 'react';
import { dispatch } from '../../../store';
import { setGoogleHolidays } from '../../../store/slices/import-holidays.slice';
import { useNavigate } from 'react-router';
import { useTranslation } from '../../useTranslation';

const useHttpPostGoogleImportHolidaysOnMount = (body: GoogleImportDto) => {
    const { t } = useTranslation('newNotifications');
    const navigate = useNavigate();
    const toastHandler = useContainer(ToastStateHandler);
    const organizationApi: OrganizationApi = useContainer(OrganizationApi);

    useEffect(() => {
        const { exec, abort } = organizationApi.googleImport({
            body,
            onSuccess: res => dispatch(setGoogleHolidays(res.body)),
            onError: error => {
                console.log(error);
                navigate('/holidays');
                toastHandler.push('error', t('holiday.importHolidaysTitle'), t('holiday.importHolidaysMessage_Failed'));
            },
        });
        exec();
        return abort;
    }, []);
};

export default useHttpPostGoogleImportHolidaysOnMount;
